module.exports = "main {\r\n  font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\r\n  text-align: center;  \r\n  display: block;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/app.component.css
// module id = ./src/app/main/app.component.css
// module chunks = main